import React, { Component } from "react";

const VoteIcon = ({ width, height, fill, voted = false, ...rest }) => {
  const active = voted == true ? fill : "";
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.33341 5.66682V12.3335H9.57368C10.2093 12.3335 10.7565 11.8849 10.8811 11.2616L11.6811 7.26164C11.8461 6.43658 11.2151 5.66682 10.3737 5.66682H7.33342L8.95059 3.24106C9.46204 2.47388 9.05908 1.43157 8.16457 1.20794L8.13286 1.20001C7.64291 1.07752 7.1258 1.24237 6.79713 1.62581L3.33341 5.66682Z"
        fill={active}
      />
      <path
        d="M3.33333 5.66682H0.666664V12.3335H3.33333M3.33333 5.66682V12.3335M3.33333 5.66682L6.79705 1.62581C7.12572 1.24237 7.64282 1.07752 8.13277 1.20001L8.16448 1.20794C9.05899 1.43157 9.46196 2.47388 8.9505 3.24106L7.33333 5.66682H10.3736C11.215 5.66682 11.846 6.43658 11.681 7.26164L10.881 11.2616C10.7564 11.8849 10.2092 12.3335 9.57359 12.3335H3.33333"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

VoteIcon.defaultProps = {
  fill: "black",
  width: 13,
  height: 13,
};

export default VoteIcon;
